export class Facility {
    Id: number;
    Name: string;
    SubAreaId: number;
    IsActive: boolean;
}
